module.exports = __webpack_public_path__ + "static/img/partner_XIII.496ff87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XIII.png
// module id = Ovbg
// module chunks = 9